common.View.create('crud::form.inputs.Tags', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad() {
		this.initTags();
	},

	initTags()
	{
		// Get the input that needs to be converted to the tags input
		let $input = this.element.find('input');

		// Get user given tag options
		let options = this.initOptions($input);

		// Run tagify
		new Tagify($input.get(0), options);
	},

    initOptions($input)
    {
        let options = [],
            whitelist = ['name', 'type', 'value', 'class'],
            attrs = $input.get(0).attributes;

        // Loop attributes of input
        for (var i = attrs.length - 1; i >= 0; i--) {
            let name = attrs[i].name;

            // Attribute is not whitelisted?
            if( !whitelist.includes(name) ) {
                // Get attr name, value
                let attrName = attrs[i].nodeName,
                    attrValue = attrs[i].nodeValue;

                if (name === 'whitelist') {
                    attrValue = attrs[i].nodeValue.split(',');
                }

                // and push into array
                options[attrName] = attrValue;
            }
        }

        return options;
    }

});
